export default "/images/d84ea105f996b9483f4499b6635dbcba.avif";